module.exports = __webpack_public_path__ + "img/locked-with-pen.23ac08f3.png";